export default __webpack_public_path__ + "6f5ae28beae028c920612d4e9fa712f3.png";